import Router from 'vue-router'
import Vue from 'vue'
import Agent from '@/components/dashboard/agent/Agent'
import Login from '@/components/index/Login'
import Referee from '@/components/dashboard/referee/Referee'
import News from '@/components/dashboard/News'
import Home from '@/components/dashboard/Home'
import Classification from '@/components/dashboard/Classification'
import Index from '@/components/index/Index'
import NewRace from '@/components/NewRace'
import CreateRace from '@/components/CreateRace'
import Racers from '@/components/Racers'
import PendingRequests from '@/components/dashboard/pending/PendingRequests'
import Point from "@/components/dashboard/point/Point";
Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/home',
            name: 'home',
            component: Home
        },
        {
            path: '/agent',
            name: 'agent',
            component: Agent
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/referee',
            name: 'referee',
            component: Referee
        }, {
            path: '/news',
            name: 'news',
            component: News
        }, {
            path: '/classification',
            name: 'classification',
            component: Classification
        }, {
            path: '/index',
            name: 'index',
            component: Index
        }, {
            path: '*',
            component: Index
        }, {
            path: '/newrequest',
            name: 'newrequest',
            component: NewRace
        },
        {
            path: '/cr',
            name: 'newrace',
            component: CreateRace
        }, {
            path: '/racers',
            name: 'racers',
            component: Racers
        }, {
            path: '/pendingrequests',
            name: 'pendingRequests',
            component: PendingRequests
        }, {
            path: '/point',
            name: 'point',
            component: Point
        }
    ]
})